// extracted by mini-css-extract-plugin
export default {"Logos":"styles_Logos__sqe5t","Logos-items":"styles_Logos-items__gb6+6"};